import { AIR_MODULE_LABEL } from '../pages/air-permitting/airCopy';

export const menuStructure = [
    { id: 'home', label: 'Home', icon: 'home-outline', path: '/', type: 'item' },
    { id: 'todo-list', label: 'To-Do List', icon: 'checkbox-outline', path: '/todo-list', type: 'item' },
    { id: 'bug-reports', label: 'Bug Reports', icon: 'bug-outline', path: '/bug-reports', type: 'item' },
    {
      id: 'reports',
      label: 'Reports',
      icon: 'bar-chart-outline',
      type: 'section',
      children: [
        { id: 'dashboard', label: 'Dashboard', icon: 'stats-chart-outline', path: '/dashboard', type: 'item' },
        { id: 'compliance-orders-report', label: 'Compliance Orders Report', icon: 'document-text-outline', path: '/compliance-orders-report', type: 'item' },
        { id: 'compliance-map', label: 'Compliance Map', icon: 'map-outline', path: '/compliance-map', type: 'item' },
        { id: 'compliance-summary-report', label: 'Compliance Summary Report', icon: 'document-attach-outline', path: '/compliance-summary-report', type: 'item' },
        { id: 'audits-report', label: 'Audits Report', icon: 'dashboard', path: '/audits-report', type: 'item' },
        { id: 'pws-report', label: 'Kenedy Water Management', icon: 'water-outline', path: '/pws-report', type: 'item' },
      ]
    },
    { id: 'calendar', label: 'Calendar', icon: 'calendar-outline', path: '/calendar', type: 'item' },
    { id: 'compliance-records', label: 'Compliance Records', icon: 'document-outline', path: '/compliance', type: 'item' },
    {
      id: 'conoco-tasks-section',
      label: 'Task List',
      icon: 'checkbox-outline',
      type: 'section',
      children: [
        { id: 'conoco-task-groups', label: 'Task Groups', icon: 'folder-open-outline', path: '/conoco-task-groups', type: 'item' },
        { id: 'conoco-tasks', label: 'Task List', icon: 'checkbox-outline', path: '/conoco-tasks', type: 'item' },
      ]
    },
    {
      id: 'audits',
      label: 'Audit Management',
      icon: 'checkmark-circle-outline',
      type: 'section',
      children: [
        { id: 'standards-and-regulations', label: 'Standards & Regulations', icon: 'library-outline', path: '/standards-and-regulations', type: 'item' },
        { id: 'audit-scopes', label: 'Audit Scopes', icon: 'folder-open-outline', path: '/audit-scopes', type: 'item' },
        { id: 'pre-audit-questionnaires', label: 'Pre-Audit Questionnaires', icon: 'clipboard-outline', path: '/pre-audit-questionnaires', type: 'item' },
        { id: 'audits', label: 'Audits', icon: 'checkmark-circle-outline', path: '/audits', type: 'item' },
        { id: 'governing-bodies', label: 'Governing Bodies', icon: 'business-outline', path: '/governing-bodies', type: 'item' },
      ]
    },
    {
      id: 'compliance-orders',
      label: 'Compliance Order Management',
      icon: 'document-text-outline',
      type: 'section',
      children: [
        { id: 'compliance-order-management', label: 'Compliance Orders', icon: 'document-text-outline', path: '/compliance-orders', type: 'item' },
        { id: 'compliance-order-verifications', label: 'Compliance Order Verifications', icon: 'checkmark-circle-outline', path: '/compliance-order-verifications', type: 'item' },
        { id: 'compliance-order-action-codes', label: 'Action Codes', icon: 'list-outline', path: '/compliance-order-action-codes', type: 'item' },
        { id: 'compliance-order-work-types', label: 'Work Types', icon: 'list-outline', path: '/compliance-order-work-types', type: 'item' }
      ]
    },
    {
      id: 'inspections',
      label: 'Inspections',
      icon: 'search-outline',
      type: 'section',
      children: [
        { id: 'drainage-recordation', label: 'Drainage Recordation', icon: 'water-outline', path: '/drainage-recordation', type: 'item' },
        { id: 'spcc-routine-inspection', label: 'SPCC Routine Inspection', icon: 'shield-checkmark-outline', path: '/spcc-routine-inspection', type: 'item' },
        { id: 'spcc-annual-inspection', label: 'SPCC Annual Inspection', icon: 'shield-checkmark-outline', path: '/spcc-annual-inspection', type: 'item' },
        { id: 'swppp-discharge-monitoring-inspection', label: 'SWPPP Discharge Monitoring Inspection', icon: 'water-outline', path: '/swppp-discharge-monitoring-inspection', type: 'item' },
        { id: 'swppp-quarterly-inspection', label: 'SWPPP Quarterly Inspection', icon: 'water-outline', path: '/swppp-quarterly-inspection', type: 'item' },
        { id: 'response-equipment-inventory-inspection', label: 'Response Equipment Inventory Inspection', icon: 'settings-outline', path: '/response-equipment-inventory-inspection', type: 'item' },
      ]
    },
    {
      id: 'testing',
      label: 'Testing',
      icon: 'flask-outline',
      type: 'section',
      children: [
        { id: 'qi-notification-exercise-log', label: 'QI Notification Exercise Log', icon: 'notifications-outline', path: '/qi-notification-exercise-log', type: 'item' },
        { id: 'annual-tabletop-exercise-log', label: 'SMT Tabletop Exercise Log', icon: 'people-outline', path: '/annual-tabletop-exercise-log', type: 'item' },
        { id: 'equipment-deployment-exercise-log', label: 'Equipment Deployment Exercise Log', icon: 'construct-outline', path: '/equipment-deployment-exercise-log', type: 'item' },
        { id: 'transfer-hose-and-pipe-testing', label: 'Transfer Hose and Pipe Testing', icon: 'construct-outline', path: '/transfer-hose-and-pipe-testing', type: 'item' },
        { id: 'environmental-sampling', label: 'Environmental Sampling', icon: 'leaf-outline', path: '/environmental-sampling', type: 'item' },
        { id: 'environmental-lab-analysis', label: 'Environmental Lab Analysis', icon: 'analytics-outline', path: '/environmental-lab-analysis', type: 'item' },
      ]
    },
    {
      id: 'maintenance',
      label: 'Maintenance',
      icon: 'build-outline',
      type: 'section',
      children: [
        { id: 'hazardous-waste-removal', label: 'Hazardous Waste Removal', icon: 'trash-outline', path: '/hazardous-waste-removal', type: 'item' },
        { id: 'sump-pump-maintenance-inspection', label: 'Sump Pump Maintenance Inspection', icon: 'settings-outline', path: '/sump-pump-maintenance-inspection', type: 'item' },
      ]
    },
    { id: 'library-of-records', label: 'Library of Records', icon: 'library-outline', path: '/library-of-records', type: 'item' },
    { id: 'sharepoint-documents', label: 'SharePoint', icon: 'cloud-outline', path: '/sharepoint-documents', type: 'item' },
    {
      id: 'r9-facility',
      label: 'R-9 Facility',
      icon: 'business-outline',
      type: 'section',
      children: [
        { id: 'authorized-waste-receipt', label: 'Authorized Waste Receipt', icon: 'receipt-outline', path: '/authorized-waste-receipt', type: 'item' },
        { id: 'analytical-result-form-for-awr', label: 'Analytical Result Form for AWR', icon: 'document-text-outline', path: '/analytical-result-form-for-awr', type: 'item' },
        { id: 'outgoing-solid-waste', label: 'Outgoing Solid Waste', icon: 'trash-outline', path: '/outgoing-solid-waste', type: 'item' },
        { id: 'outgoing-produced-water-waste', label: 'Outgoing Produced Water Waste', icon: 'water-outline', path: '/outgoing-produced-water-waste', type: 'item' },
      ]
    },
    {
      id: 'r9-administration',
      label: 'R-9 Administration',
      icon: 'settings-outline',
      type: 'section',
      children: [
        { id: 'awr-approvers', label: 'AWR Approvers', icon: 'people-outline', path: '/awr-approvers', type: 'item' },
        { id: 'invoicing', label: 'Invoicing', icon: 'card-outline', path: '/invoicing', type: 'item' },
        { id: 'waste-generator-sites', label: 'Waste Generator Sites', icon: 'business-outline', path: '/waste-generator-sites', type: 'item' },
        { id: 'billing-companies', label: 'Billing Companies', icon: 'card-outline', path: '/billing-companies', type: 'item' },
        { id: 'waste-transporters', label: 'Waste Transporters', icon: 'car-outline', path: '/waste-transporters', type: 'item' },
        { id: 'disposal-sites', label: 'Disposal Sites', icon: 'location-outline', path: '/disposal-sites', type: 'item' },
        { id: 'r9-quarterly-report', label: 'R9 Reporting', icon: 'document-text-outline', path: '/r9/quarterly-report', type: 'item' },
      ]
    },
    {
      id: 'construction-permitting',
      label: 'Project Permitting',
      icon: 'construct-outline',
      type: 'section',
      children: [
        { id: 'project-permitting', label: 'Project Workspace', icon: 'briefcase-outline', path: '/project-permitting', type: 'item' },
        { id: 'project-files', label: 'Project Files', icon: 'folder-outline', path: '/project-files', type: 'item' },
      ]
    },
    {
      id: 'engines',
      label: 'Engines',
      icon: 'speedometer-outline',
      type: 'section',
      children: [
        { id: 'fields', label: 'Fields', icon: 'location-outline', path: '/fields', type: 'item' },
        { id: 'wells', label: 'Wells', icon: 'water-outline', path: '/wells', type: 'item' },
        { id: 'add-engine', label: 'Engines', icon: 'speedometer-outline', path: '/engines', type: 'item' },
        { id: 'add-engine-use', label: 'Add Engine Use', icon: 'add-circle-outline', path: '/engines/engine-uses/add', type: 'item' },
        { id: 'engine-running-hours', label: 'Engine Running Hours', icon: 'time-outline', path: '/engine-running-hours', type: 'item' },
      ]
    },
    {
      id: 'air-permitting',
      label: AIR_MODULE_LABEL,
      icon: 'leaf-outline',
      type: 'section',
      children: [
        { id: 'air-glycol-pumps', label: 'Glycol Pumps', icon: 'list-outline', path: '/air-glycol-pumps', type: 'item' },
        { id: 'air-flares', label: 'Flares', icon: 'sunny-outline', path: '/air-flares', type: 'item' },
        { id: 'air-glycol-pump-log', label: 'Daily Glycol Pump Log', icon: 'speedometer-outline', path: '/air-glycol-pump-log', type: 'item' },
        { id: 'air-opacity-monitoring', label: 'Opacity Monitoring', icon: 'search-outline', path: '/air-opacity-monitoring', type: 'item' },
        { id: 'air-flare-log', label: 'Daily Flare Log', icon: 'sunny-outline', path: '/air-flare-log', type: 'item' },
      ]
    },
    {
      id: 'pws-compliance',
      label: 'PWS Compliance',
      icon: 'water-outline',
      type: 'section',
      children: [
        { id: 'weekly-flow-meter-logs', label: 'Weekly Flow Meter Logs', icon: 'speedometer-outline', path: '/weekly-flow-meter-logs', type: 'item' },
        { id: 'weekly-equipment-service-logs', label: 'Weekly Equipment Service Logs', icon: 'settings-outline', path: '/weekly-equipment-service-logs', type: 'item' },
        { id: 'weekly-pws-water-monitoring', label: 'Weekly PWS Water Monitoring', icon: 'water-outline', path: '/weekly-pws-water-monitoring', type: 'item' },
        { id: 'monthly-pws-water-sample', label: 'Monthly PWS Water Sample', icon: 'flask-outline', path: '/monthly-pws-water-sample', type: 'item' },
        { id: 'monthly-pws-analytical-report-review', label: 'Monthly PWS Analytical Report Review', icon: 'document-text-outline', path: '/monthly-pws-analytical-report-review', type: 'item' },
        { id: 'quarterly-dlqor', label: 'Quarterly DLQOR', icon: 'document-outline', path: '/quarterly-dlqor', type: 'item' },
        { id: 'quarterly-colorimeter-calibration-verification', label: 'Quarterly Colorimeter Calibration Verification', icon: 'color-palette-outline', path: '/quarterly-colorimeter-calibration-verification', type: 'item' },
      ]
    },
    {
      id: 'reclaimed-water-compliance',
      label: 'Reclaimed Water Compliance',
      icon: 'sprinkler-variant',
      type: 'section',
      children: [
        { id: 'weekly-reclaimed-water-monitoring', label: 'Weekly Reclaimed Water Monitoring', icon: 'water-outline', path: '/weekly-reclaimed-water-monitoring', type: 'item' },
        { id: 'monthly-reclaimed-water-sample', label: 'Monthly Reclaimed Water Sample', icon: 'flask-outline', path: '/monthly-reclaimed-water-sample', type: 'item' },
        { id: 'monthly-reclaimed-analytical-report-review', label: 'Monthly Reclaimed Analytical Report Review', icon: 'document-text-outline', path: '/monthly-reclaimed-analytical-report-review', type: 'item' },
        { id: 'monthly-lab-summary', label: 'Monthly Reclaimed Water Analytical Data Summary', icon: 'analytics-outline', path: '/monthly-lab-summary', type: 'item' },
        { id: 'semi-annual-reclaimed-water-sample', label: 'Semi-Annual Reclaimed Water Sample', icon: 'flask-outline', path: '/semi-annual-reclaimed-water-sample', type: 'item' },
        { id: 'semi-annual-reclaimed-analytical-report-review', label: 'Semi-Annual Reclaimed Analytical Report Review', icon: 'document-text-outline', path: '/semi-annual-reclaimed-analytical-report-review', type: 'item' },
        { id: 'annual-reclaimed-water-sample', label: 'Annual Reclaimed Water Sample', icon: 'flask-outline', path: '/annual-reclaimed-water-sample', type: 'item' },
        { id: 'annual-reclaimed-analytical-report-review', label: 'Annual Reclaimed Analytical Report Review', icon: 'document-text-outline', path: '/annual-reclaimed-analytical-report-review', type: 'item' },
        { id: 'annual-analytical-data-summary', label: 'Annual Analytical Data Summary', icon: 'analytics-outline', path: '/annual-analytical-data-summary', type: 'item' },
      ]
    },
    {
      id: 'administration',
      label: 'Administration',
      icon: 'settings-outline',
      type: 'section',
      children: [
        { id: 'users', label: 'User Management', icon: 'people-outline', path: '/users', type: 'item' },
        { id: 'user-access-matrix', label: 'User Access Matrix', icon: 'grid-outline', path: '/users/matrix', type: 'item' },
        { id: 'company-management', label: 'Company Management', icon: 'business-outline', path: '/company-management', type: 'item' },
        { id: 'site-management', label: 'Site Management', icon: 'location-outline', path: '/site-management', type: 'item' },
        { id: 'form-status-management', label: 'Form Status Management', icon: 'calendar-outline', path: '/form-status-management', type: 'item' },
        { id: 'templates', label: 'Templates', icon: 'copy-outline', path: '/templates', type: 'item' },
        {
          id: 'administration-reference-tables',
          label: 'Reference Tables',
          icon: 'list-outline',
          type: 'section',
          children: [
            { id: 'manage-compliance-aspects', label: 'Manage Compliance Aspects', icon: 'options-outline', path: '/manage-compliance-aspects', type: 'item' },
            { id: 'manage-compliance-elements', label: 'Manage Compliance Elements', icon: 'list-outline', path: '/manage-compliance-elements', type: 'item' },
            { id: 'manage-record-types', label: 'Manage Record Types', icon: 'document-outline', path: '/manage-record-types', type: 'item' },
            { id: 'manage-project-types', label: 'Manage Project Types', icon: 'folder-outline', path: '/manage-project-types', type: 'item' },
            { id: 'manage-permit-agencies', label: 'Manage Permit Agencies', icon: 'business-outline', path: '/manage-permit-agencies', type: 'item' },
            { id: 'manage-project-permit-types', label: 'Manage Project Permit Types', icon: 'document-text-outline', path: '/manage-project-permit-types', type: 'item' },
            { id: 'manage-project-elements', label: 'Manage Project Elements', icon: 'list-outline', path: '/manage-project-elements', type: 'item' },
            { id: 'waste-units-and-conversions', label: 'Waste Unit Conversions', icon: 'calculator-outline', path: '/waste-units-and-conversions', type: 'item' },
            { id: 'hazardous-waste-disposal-site-management', label: 'Hazardous Waste Disposal Sites', icon: 'trash-outline', path: '/hazardous-waste-disposal-site-management', type: 'item' },
          ]
        },
        {
          id: 'administration-pws-management',
          label: 'PWS Management',
          icon: 'water-outline',
          type: 'section',
          children: [
            { id: 'pws-log-record-assignment', label: 'PWS Log Record Assignment', icon: 'person-outline', path: '/pws-log-record-assignment', type: 'item' },
            { id: 'manage-approval-parameters', label: 'Manage Approval Parameters', icon: 'checkmark-circle-outline', path: '/manage-approval-parameters', type: 'item' },
          ]
        },
        {
          id: 'administration-development',
          label: 'Development',
          icon: 'build-outline',
          type: 'section',
          children: [
            { id: 'scheduler-monitor', label: 'Scheduler Monitor', icon: 'time-outline', path: '/scheduler-monitor', type: 'item' },
            { id: 'qa-lab', label: 'QA Lab', icon: 'flask-outline', path: '/qa-lab', type: 'item' },
            { id: 'custom-form-builder', label: 'Custom Form Builder', icon: 'create-outline', path: '/custom-form-builder', type: 'item' },
            { id: 'custom-form-entry', label: 'Custom Form Entry', icon: 'document-text-outline', path: '/custom-form-entry', type: 'item' },
            { id: 'email-test', label: 'Email Catalog', icon: 'mail-outline', path: '/email-test', type: 'item' },
            { id: 'pdf-testing', label: 'PDF Testing', icon: 'document-text-outline', path: '/pdf-testing', type: 'item' },
            { id: 'sharepoint-admin-resources', label: 'SharePoint Resources', icon: 'cloud-outline', path: '/sharepoint-admin-resources', type: 'item' },
          ]
        },
      ]
    },
  ];
